import React from "react";
import { createRoot } from "react-dom/client";
import App from "./main_app/App";

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
